import React from 'react';
import { Flex, Form, Radio, Input, InputNumber, DatePicker, Button, Divider, message } from 'antd';
import { TagOutlined, UsergroupAddOutlined, CreditCardOutlined } from '@ant-design/icons';
import NavItem from '../../../components/nav-item';
import SwitchShop from '../../shop/switch-shop';
import { getCurrentShopId } from '../../shop/get-current-shop';
import SelectGoods from '../../goods/select-goods';
import dayjs from 'dayjs'

const iconStyle = {
    fontSize: 28,
}

export default () => {
    const params = new URLSearchParams(window.location.search);
    const action = params.get('action');
    const couponTmpId = params.get('couponTmpId');
    const [shopId, setShopId] = React.useState(null);
    const [form] = Form.useForm();
    const couponType = Form.useWatch('type', form);
    const scope = Form.useWatch('scope', form);
    
    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
        };
        
        fetchShopId();
    }, []);
    
    React.useEffect(() => {
        if (shopId && couponTmpId) {
            initFome(couponTmpId);
        }
    }, [shopId, action, couponTmpId]);

    const initFome = async (couponTmpId) => { 
        const data = await getCouponTmpDetail(couponTmpId);
        console.log('initFome', data);
        form.setFieldsValue(data);
    };

    const submit = async () => { 
        if (!shopId) return;
        
        const values = await form.validateFields();
        values.shopId = shopId;

        if(values.goodsIds) values.goodsIds = values.goodsIds.map(item => item.goodsId);
        if(values.startTime) values.startTime = values.startTime.startOf('day').toDate();
        if(values.endTime) values.endTime = values.endTime.endOf('day').toDate();
        create(values);
    };

    const create = async (values) => { 
        const response = await fetch(`/api/coupon/create`, {
            method: "POST",
            headers: {  
                "Content-Type": "application/json",
            },
            body: JSON.stringify(values),
        });

        const result = await response.json();
        if(result?.success) {
            message.success('创建成功');
            window.location.href = '/promotion/coupon';
        }else{
            message.error(`创建失败${result?.data}`);
        }
    };

    const getCouponTmpDetail = async (couponTmpId) => { 
        if (!shopId) return;
        
        const url = '/api/coupon/detail';
        const response = await fetch(`${url}?couponTmpId=${couponTmpId}&shopId=${shopId}`);
        const result = await response.json();

        if (result?.success) {
            result.data.startTime = dayjs(result.data.startTime);

            if(result.data.goodsIds) {
                result.data.scope = 2;
                result.data.goodsIds = result.data.goods;
            }else{
                result.data.scope = 1;
            }
            if(result.data.endTime) result.data.endTime = dayjs(result.data.endTime);

            return (result.data);
        }else {
            message.error(result.message);
        }
    };

    return (
        <div>
            <SwitchShop />
            <h2>{action === 'view' ? '查看' : '创建'}优惠券</h2>
            <Form form={form} disabled={action === 'view' ? true : false}>
                <Form.Item
                    name='title'
                    label="优惠券名称"
                    rules={[{ required: true, message: '请输入优惠券名称' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name='description'
                    label="备注"
                    help="仅内部可见"
                >
                    <Input count={{max: 60, show: true}} />
                </Form.Item>

                <Form.Item
                    name='type'
                    label="优惠券类型"
                    rules={[{ required: true, message: '' }]}
                >
                    <Radio.Group optionType='button' options={[{label: '代金券', value: 1}, {label: '折扣券', value: 2}]} />
                </Form.Item>

                <Form.Item
                    name='scope'
                    label="适用范围"
                    rules={[{ required: true, message: '' }]}
                >
                    <Radio.Group optionType='button' options={[{label: '全部商品', value: 1}, {label: '部分商品', value: 2}]} />
                </Form.Item>

                {scope === 2 && <Form.Item 
                    label="选择商品"
                    name='goodsIds'
                    rules={[{ required: true, message: '' }]}
                >
                    <SelectGoods multiple={true} />
                </Form.Item>}

                <Flex gap={10}>
                    <Form.Item
                        name='triggerAmount'
                        label="优惠门槛"
                        rules={[{ required: true, message: '' }]}
                    >
                        <InputNumber addonAfter='元' addonBefore='满' />
                    </Form.Item>

                    <Form.Item
                        name='offerAmount'
                        label="优惠"
                        rules={[{ required: true, message: '' }]}
                    >
                        <InputNumber addonAfter={couponType === 1 ? '元' : '%'} addonBefore={couponType === 1 ? '减' : '折扣'} />
                    </Form.Item>
                </Flex>

                <Form.Item
                    name='inventory'
                    label="库存"
                    rules={[{ required: true, message: '请填写库存' }]}
                >
                    <InputNumber addonAfter='张' placeholder='不限制' />
                </Form.Item>

                <Form.Item
                    name='limitPerUser'
                    label="每人限领"
                >
                    <InputNumber addonAfter='张/天' placeholder='不限制' />
                </Form.Item>

                <Form.Item
                    name='limitPerDay'
                    label="每日发放"
                >
                    <InputNumber addonAfter='张' placeholder='不限制' />
                </Form.Item>

                <Form.Item
                    name='afterDays'
                    label="使用有效期"
                    initialValue={60}
                    rules={[{ required: true, message: '' }]}
                >
                    <InputNumber addonBefore='领取后' addonAfter='天内' placeholder='不限制' />
                </Form.Item>

                <Flex gap={10}>
                    <Form.Item
                        name='startTime'
                        label="开始发放"
                        help="不选日期，则创建后开始发放"
                    >
                        <DatePicker 
                            changeOnScroll={true}
                            needConfirm={false}
                            showNow={true}
                        />
                    </Form.Item>

                    <Form.Item
                        name='endTime'
                        label="结束发放"
                        help="不选日期，则长期有效"
                    >
                        <DatePicker 
                            changeOnScroll={true}
                            needConfirm={false}
                            showNow={true}
                        />
                    </Form.Item>
                </Flex>
                <Divider />
                <Flex justify='center' gap={10}>
                    <Button>取消</Button>
                    <Button type='primary' onClick={submit}>提交</Button>
                </Flex>
            </Form>
        </div>
    )
}